{
  "erreurs.code.CONTINUITY_REPRISE_HORS_ETAT": "Seule une demande de même nature, en échec ou interrompue sur l’hôte, peut être reprise.",
  "erreurs.code.CONTINUITY_REQUEST_UNKNOWN": "Cette demande de sauvegarde ou de restauration est inconnue : relisez la liste des demandes.",
  "erreurs.code.PROFIL_DEJA_ATTRIBUE": "Ce compte tient déjà ce profil de plateforme.",
  "erreurs.code.PROFIL_NON_DELEGABLE": "Seuls les profils « Exploitation en lecture » et « Support » se délèguent ici ; l’administration de la plateforme se nomme à deux personnes.",
  "erreurs.code.TACHE_DEJA_EN_COURS": "Une exécution de cette tâche planifiée est déjà en cours : attendez sa fin avant de la relancer.",
  "journalAudit.action.platform.profile_granted": "Profil de plateforme attribué",
  "journalAudit.action.platform.profile_revoked": "Profil de plateforme retiré",
  "journalAudit.action.platform.scheduled_task_rerun": "Tâche planifiée relancée"
}
